export function resolveNestedSubPropertyValue(value: unknown, subProperty: string): unknown {
  return subProperty.split('.').reduce<unknown>((accumulator, key) => {
    if(accumulator === null || accumulator === undefined) {
      return null
    }
    return (accumulator as Record<string, unknown>)[key] ?? null
  }, value)
}
